import { configureStore } from '@reduxjs/toolkit'
import accountSlice from './account/account.slice';
import appSlice from './app/app.slice';
import onBoardingSlice from './onBoarding/onBoarding.slice';
import partnerSlice from 'partner/partner.slice';

const store = configureStore({
  reducer: {
    account: accountSlice,
    app: appSlice,
    onBoarding: onBoardingSlice,
    partner: partnerSlice
  },
  devTools: process.env.NODE_ENV === "development"
});

export default store;
